import { EXPRESS_API } from 'configs/api/expressApi';

export const blockEmailRecepient = async (url: string) => {
  const response = await EXPRESS_API.put(url);
  return response.data;
};
